import {
  ActivityFilters,
  AssetActivity,
  SystemActivity,
} from "../models/activityLog";
import { Asset } from "../models/assets";
import { System } from "../models/systems";
import { AssetsPaginatedResponse, CursorState, ProjectId } from "../types";
import { Endpoints } from "./constants";
import { AssetsHttpClient } from "./createAssetsHttpClient";
import { buildSearchString } from "./helpers";

export const getActivityLogClient = (
  http: AssetsHttpClient,
  projectId: ProjectId
) => {
  const base = http.getAssetsServiceBasePath(projectId, "v2");

  return {
    getAssetActivity: (
      assetId: Asset["id"],
      cursorState?: CursorState,
      { publishedBefore }: ActivityFilters = {}
    ): Promise<AssetsPaginatedResponse<AssetActivity[]>> => {
      const searchString = buildSearchString({
        cursorState,
        "filter[publishedBefore]": publishedBefore,
      });

      return http.get<AssetsPaginatedResponse<AssetActivity[]>>(
        `${base}/${Endpoints.AssetsActivityStreams}/${assetId}${
          searchString ? `?${searchString}` : ""
        }`
      );
    },

    getSystemActivity: (
      systemId: System["id"],
      cursorState?: CursorState
    ): Promise<AssetsPaginatedResponse<SystemActivity[]>> => {
      const searchString = buildSearchString({ cursorState });

      return http.get<AssetsPaginatedResponse<SystemActivity[]>>(
        `${base}/${Endpoints.SystemsActivityStreams}/${systemId}${
          searchString ? `?${searchString}` : ""
        }`
      );
    },
  };
};

/**
 * The shape returned by {@link getActivityLogClient}.
 * Exported so consumers can type variables without spelling out
 * `ReturnType<typeof getActivityLogClient>`.
 */
export type ActivityLogClient = ReturnType<typeof getActivityLogClient>;
